import angular from 'angular'
import routers from './routers'

import { selection4th } from 'redevConfig'
const list = (selection4th && selection4th.list) || ''
const selectionCtrl4 = list ? require(`redevelopment/input/selection4th/${list.controllerName}`) : require('./selectionCtrl.js')

export default angular.module('input.certification.selection4th', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }]).controller("selectionCtrl4", selectionCtrl4.default)
    .filter('timestrsub', function () {
        return function (data) {
            data = data || "";
            return data.substring(0, 10)
        }
    }).filter('Seldate', () => function (data) {
        data = data || ''
        return data.substring(0, 10)
    })
    .filter('secondDate', () => function (data) {
        if (!data) return data
        if (data.length < 11) return data += ' 00:00'
        if (data.length == 16) return data
        return data.substring(0, data.length - 3)
    })
    .name


// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/selection4th/index.js